import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageLayoutComponent } from '@client-monorepo/common/ui-components';
import { FileApiService } from '@client-monorepo/common/file-api';

@Component({
  selector: 'profile-applet-terms-and-conditions',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
  templateUrl: './terms-and-conditions.component.html',
  styleUrl: './terms-and-conditions.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TermsAndConditionsComponent {
  content = signal('');

  fileApiService = inject(FileApiService);

  constructor() {
    this.getContent();
  }

  getContent(): void {
    this.fileApiService.getTermsAndConditionPage().subscribe((res: any) => {
      this.content.set(res);
    });
  }
}
